import { SyntheticEvent, useCallback, useState } from "react";
import styles from "./products-list.module.css";

type ProductImageProps = {
  src: string;
  fullImage: string;
  alt: string;
  onExpand: (url: string) => void;
};

const ProductImage = ({
  src,
  fullImage,
  alt,
  onExpand,
}: ProductImageProps): JSX.Element => {
  const [canExpand, setCanExpand] = useState(false);

  const updateCanExpand = useCallback((img: HTMLImageElement) => {
    setCanExpand(
      img.naturalWidth > img.clientWidth + 1 ||
        img.naturalHeight > img.clientHeight + 1
    );
  }, []);

  const handleLoad = (event: SyntheticEvent<HTMLImageElement>) => {
    updateCanExpand(event.currentTarget);
  };

  return (
    <div className={styles["item__image-wrap"]}>
      <img
        className={styles["item__image"]}
        src={src}
        alt={alt}
        onLoad={handleLoad}
      />
      {canExpand && (
        <button
          type="button"
          className={styles["item__image-expand"]}
          aria-label={`View full size: ${alt}`}
          onClick={() => onExpand(fullImage)}
        >
          ⤢
        </button>
      )}
    </div>
  );
};

export default ProductImage;
